<template>
  <div class="hello">
    <el-calendar v-model="value" @click.native="changec" ref="cal">
      <template slot="dateCell" slot-scope="{ date, data }">
        <div :class="data.isSelected ? 'is-selected' : ''">
          <div class="title">{{ data.day.slice(5) }}</div>
          <div :class="genClass(data.day)" v-show="data.type === 'current-month'">
            {{ getNum(data.day) }}
          </div>
        </div>
      </template>
    </el-calendar>
    <el-collapse v-model="activeNames">
      <el-collapse-item title="到期列表" name="1">
        <template>
          <!-- 统计数据 -->
          <el-row :gutter="20" class="statistics-row">
            <el-col :xs="12" :sm="5">
              <div class="statistic-item zs-item">
                <el-statistic group-separator="," :precision="2" :value="totalAmountZS" title="理财 (万)"></el-statistic>
              </div>
            </el-col>
            <el-col :xs="12" :sm="5">
              <div class="statistic-item zgc-item">
                <el-statistic group-separator="," :precision="2" :value="totalAmountZGC" title="中关村 (万)"></el-statistic>
              </div>
            </el-col>
            <el-col :xs="12" :sm="5">
              <div class="statistic-item jc-item">
                <el-statistic group-separator="," :precision="2" :value="totalAmountJC" title="金城 (万)"></el-statistic>
              </div>
            </el-col>
            <el-col :xs="12" :sm="5">
              <div class="statistic-item fm-item">
                <el-statistic group-separator="," :precision="2" :value="totalAmountFM" title="富民 (万)"></el-statistic>
              </div>
            </el-col>
            <el-col :xs="24" :sm="4">
              <div class="statistic-item month-item">
                <el-statistic group-separator="," :precision="2" :value="totalAmount" title="总存款"></el-statistic>
              </div>
            </el-col>
          </el-row>
          <!-- 各银行金额 -->
          <el-row :gutter="20" class="statistics-row">
            <el-col :xs="12" :sm="5">
              <div class="statistic-item zs-item">
                <el-statistic group-separator="," :precision="2" :value="everydayInterestZS" title="理财 (元)"></el-statistic>
              </div>
            </el-col>
            <el-col :xs="12" :sm="5">
              <div class="statistic-item zgc-item">
                <el-statistic group-separator="," :precision="2" :value="everydayInterestZGC" title="中关村 (元)"></el-statistic>
              </div>
            </el-col>
            <el-col :xs="12" :sm="5">
              <div class="statistic-item jc-item">
                <el-statistic group-separator="," :precision="2" :value="everydayInterestJC" title="金城 (元)"></el-statistic>
              </div>
            </el-col>
            <el-col :xs="12" :sm="5">
              <div class="statistic-item fm-item">
                <el-statistic group-separator="," :precision="2" :value="everydayInterestFM" title="富民 (元)"></el-statistic>
              </div>
            </el-col>
            <el-col :xs="24" :sm="4">
              <div class="statistic-item month-item">
                <el-statistic group-separator="," :precision="2" :value="monthInterest" title="本月总利息"></el-statistic>
              </div>
            </el-col>
          </el-row>
          <!-- 到期列表数据表 -->
          <el-table :data="tableData" show-summary :summary-method="getSummaries" :default-sort="{ prop: 'end', order: 'ascending' }" class="data-table">
            <el-table-column type="index" width="50" align="center" label="No."> </el-table-column>
            <el-table-column prop="type" label="APP">
              <template slot-scope="scope">
                <span :class="`interest ${scope.row.type}`">{{ scope.row.type | appName }}</span>
              </template>
            </el-table-column>
            <el-table-column label="期限(月)" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.range }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="rate" label="利率(%)" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.rate || "--" }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="amount" label="金额(万)" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.amount || "--" }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="end" label="到期日" min-width="100" sortable></el-table-column>
          </el-table>
        </template>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import moment from "moment";
import origin from "./list";
let nameMap = {
  dxm: "度小满",
  zgc: "中关村银行",
  fm: "富民银行",
  jc: "金城银行",
  zs: "个人理财",
};
export default {
  name: "HelloWorld",
  data() {
    return {
      activeNames: [],
      activeNames2: [],
      value: new Date(),
      list: [],
      curMonth: moment().format("YYYY-MM"),
      tableData: origin,
    };
  },
  computed: {
    // 每日利息：计算方法
    // 循环tableData中的每一项，计算每一项的利息，再累加起来
    // 每一项利息的计算方法：
    // 利息 = rate * 100 * amount / 365

    everydayInterestZS() {
      let total = 0;
      this.tableData.forEach((item) => {
        if (item.type === "zs" && item.rate && item.amount) {
          total += (item.rate * 100 * item.amount) / 365;
        }
      });
      return total;
    },
    everydayInterestZGC() {
      let total = 0;
      this.tableData.forEach((item) => {
        if (item.type === "zgc" && item.rate && item.amount) {
          total += (item.rate * 100 * item.amount) / 365;
        }
      });
      return total;
    },
    everydayInterestJC() {
      let total = 0;
      this.tableData.forEach((item) => {
        if (item.type === "jc" && item.rate && item.amount) {
          total += (item.rate * 100 * item.amount) / 365;
        }
      });
      return total;
    },
    everydayInterestFM() {
      let total = 0;
      this.tableData.forEach((item) => {
        if (item.type === "fm" && item.rate && item.amount) {
          total += (item.rate * 100 * item.amount) / 365;
        }
      });
      return total;
    },
    totalAmountZS() {
      let total = 0;
      this.tableData.forEach((item) => {
        if (item.type === "zs" && item.amount) {
          total += Number(item.amount);
        }
      });
      return total;
    },
    totalAmountZGC() {
      let total = 0;
      this.tableData.forEach((item) => {
        if (item.type === "zgc" && item.amount) {
          total += Number(item.amount);
        }
      });
      return total;
    },
    totalAmountJC() {
      let total = 0;
      this.tableData.forEach((item) => {
        if (item.type === "jc" && item.amount) {
          total += Number(item.amount);
        }
      });
      return total;
    },
    totalAmountFM() {
      let total = 0;
      this.tableData.forEach((item) => {
        if (item.type === "fm" && item.amount) {
          total += Number(item.amount);
        }
      });
      return total;
    },
    totalAmount() {
      return this.totalAmountZS + this.totalAmountZGC + this.totalAmountJC + this.totalAmountFM;
    },
    // 每月利息：计算方法
    // 每日利息 * 当月的天数
    monthInterest() {
      let daysInMonth = moment().daysInMonth();
      return (this.everydayInterestZS + this.everydayInterestZGC + this.everydayInterestJC + this.everydayInterestFM) * daysInMonth;
    },
    genClass() {
      return (day) => {
        let obj = this.list.find((obj) => obj.time === day);
        if (obj) {
          return `interest ${obj.type}`;
        } else {
          return "interest";
        }
      };
    },
    getNum() {
      return (day) => {
        let obj = this.list.find((obj) => obj.time === day);
        if (obj) {
          return obj.interest;
        } else {
          return "";
        }
      };
    },
  },
  mounted() {
    this.generateList(origin);
  },
  filters: {
    appName(type) {
      return nameMap[type];
    },
  },
  methods: {
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (column.property === "amount") {
          const values = data.map((item) => Number(item[column.property]));
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          return;
        }
        if (column.property === "rate") {
          let totalWeightedRate = 0;
          let totalAmount = 0;
          data.forEach((item) => {
            const rate = Number(item.rate);
            const amount = Number(item.amount);
            if (!isNaN(rate) && !isNaN(amount)) {
              totalWeightedRate += rate * amount;
              totalAmount += amount;
            }
          });
          if (totalAmount !== 0) {
            sums[index] = (totalWeightedRate / totalAmount).toFixed(2);
          } else {
            sums[index] = "";
          }
          return;
        }
        sums[index] = "";
      });
      return sums;
    },
    generateList(arr) {
      let temp = [];
      arr.forEach((obj) => {
        let res = this.genDateList(obj);
        temp = temp.concat(res);
      });
      this.list = this.quChong(temp);
      this.setTitle(this.curMonth);
    },
    genDateList({ start, end, range, type, interest, dateType = "months", keepDay = false }) {
      let temp = [];
      let s = moment(start);
      let e = moment(end);
      let t = dateType;
      let first = true; // 首次循环的锁
      let count = 0;
      for (let i = moment(s); i <= e; ) {
        // 第一次循环不Push
        if (!first) {
          temp.push({
            time: i.format("YYYY-MM-DD"),
            interest: interest,
            type: type,
          });
        }
        first = false;
        count++;
        if (keepDay && t === "months") {
          // 从起始日重新推算，避免2月被截断到28号后后续日期全部漂移到28号
          i = moment(start).add(count * range, "months");
        } else {
          i = i.add(range, t);
        }
      }
      return temp;
    },
    quChong(arr) {
      let temp = [];
      arr.forEach((obj) => {
        let target = temp.find((_obj) => _obj.time === obj.time);
        if (target) {
          target.interest += obj.interest;
        } else {
          temp.push(obj);
        }
      });
      return temp;
    },
    changec(e) {
      this.curMonth = this.$refs.cal.curMonthDatePrefix;
    },
    setTitle(m) {
      let sum = this.list.reduce((total, cur) => {
        if (m === cur.time.slice(0, 7)) {
          return total + cur.interest;
        } else {
          return total;
        }
      }, 0);
      document.title = `付息时间表（${sum}）`;
    },
  },
  watch: {
    curMonth: {
      handler: function (n, o) {
        this.setTitle(n);
      },
      immediate: true,
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.is-selected {
  color: #2980b9;
  font-weight: bold;
}

.hello::v-deep .el-calendar-table .el-calendar-day {
  padding: 0;

  & > div {
    padding-top: 12px;
  }
}

.hello::v-deep .title {
  font-size: 12px;
  text-align: left;
  padding-left: 20px;
}

.hello::v-deep .interest {
  display: inline-block;
  font-weight: bold;
}

.hello::v-deep .el-calendar-day .interest {
  margin-top: 17px;
}

.hello::v-deep .interest.dxm {
  color: #e74c3c;
}

.hello::v-deep .interest.zgc {
  color: #3498db;
}

.hello::v-deep .interest.fm {
  color: #1abc9c;
}

.hello::v-deep .interest.jc {
  color: #ffa500;
}

.hello::v-deep .interest.zs {
  color: #9b022d;
}

.hello::v-deep .el-statistic .title {
  padding-left: 0;
}

.el-collapse {
  margin: 0 20px;
}

/* 统计数据模块样式 */
.statistics-row {
  margin-bottom: 30px;
  background: #ffffff;
  padding: 10px;
  border-radius: 12px;
  /* border: 1px solid #ebeef5; */
  /* box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.05); */

  .statistic-item {
    text-align: center;
    padding: 15px 10px;
    margin-bottom: 10px;
    border-radius: 8px;
    transition: all 0.3s ease;
    border: 1px solid transparent;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    }

    &::v-deep .el-statistic {
      display: flex;
      flex-direction: column;
      align-items: center;

      .title {
        color: #606266;
        font-size: 14px;
        margin-bottom: 10px;
        display: block;
        text-align: center;
        font-weight: 500;
      }
      .con {
        display: flex;
        justify-content: center;
        .number {
          font-size: 24px;
          color: #303133;
          font-weight: bold;
          font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
        }
      }
    }

    &.zs-item {
      background: linear-gradient(135deg, #fff0f3 0%, #ffe4e8 100%);
      border-left: 4px solid #9b022d;
      &::v-deep .number {
        color: #9b022d !important;
      }
    }
    &.zgc-item {
      background: linear-gradient(135deg, #f0f7ff 0%, #e1f0ff 100%);
      border-left: 4px solid #3498db;
      &::v-deep .number {
        color: #3498db !important;
      }
    }
    &.jc-item {
      background: linear-gradient(135deg, #fffaf0 0%, #fff0e1 100%);
      border-left: 4px solid #ffa500;
      &::v-deep .number {
        color: #ffa500 !important;
      }
    }
    &.fm-item {
      background: linear-gradient(135deg, #f0fff4 0%, #e1fff0 100%);
      border-left: 4px solid #1abc9c;
      &::v-deep .number {
        color: #1abc9c !important;
      }
    }
    &.month-item {
      background: linear-gradient(135deg, #fff5f0 0%, #ffe8e1 100%);
      border-left: 4px solid #e67e22;
      &::v-deep .number {
        color: #e67e22 !important;
      }
    }
  }
}

/* 表格模块样式 */
.data-table {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);

  &::v-deep {
    .el-table__header {
      th {
        background-color: #f5f7fa;
        color: #606266;
        font-weight: 600;
      }
    }
    .el-table__footer-wrapper {
      .el-table__footer {
        font-weight: bold;
        color: #e67e22;
      }
    }
  }
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
  .el-collapse {
    margin: 0 10px;
  }

  .statistics-row {
    padding: 10px 5px;
    margin-bottom: 20px;

    .statistic-item {
      padding: 12px 5px;
      margin-bottom: 8px;

      &::v-deep .el-statistic {
        .title {
          font-size: 12px;
          margin-bottom: 5px;
        }
        .con {
          .number {
            font-size: 18px;
          }
        }
      }
    }
  }

  .data-table {
    &::v-deep {
      .el-table__cell {
        padding: 8px 0;
        font-size: 12px;
      }
      .el-table__header th {
        font-size: 12px;
      }
    }
  }

  .hello::v-deep .title {
    padding-left: 2px;
  }
}
.el-collapse-item::v-deep .el-collapse-item__header {
  opacity: 0;
}
</style>
